import { isRouteErrorResponse, useRouteError, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
// material-ui
import Alert from '@mui/material/Alert';

export default function ErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to / for any unknown/unhandled error
    if (!isRouteErrorResponse(error) || ![404, 401, 503, 418].includes(error.status)) {
      navigate('/', { replace: true });
    }
  }, [error, navigate]);

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <Alert color="error">Error 404 - This page doesn't exist!</Alert>;
    }
    if (error.status === 401) {
      return <Alert color="error">Error 401 - You aren't authorized to see this</Alert>;
    }
    if (error.status === 503) {
      return <Alert color="error">Error 503 - Looks like our API is down</Alert>;
    }
    if (error.status === 418) {
      return <Alert color="error">Error 418 - Contact administrator</Alert>;
    }
  }

  // While redirecting, render nothing
  return null;
}
